import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { AdapterService } from './adapter.service';
import { environment } from '../../../environments/environment';
const routes = {
  user: () => 'users',
  isExistingCustomer: () => 'is-customer-exists',
  existingCustomer: () => 'existing-customer',
  getExistingByCustomerNo: () => 'getexistingbycustomerno',
  userShipTo: () => 'userShipTo',
  userBillTo: () => 'userCompanyBillTo',
  userCompany: () => 'userCompany'
}
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private apiService: ApiService,
    private readonly _adapterService: AdapterService) { }

  create(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}`, model);
  }
  createExistingCustomer(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}/${routes.existingCustomer()}`, model);
  }
  isExistingCustomer(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}/${routes.isExistingCustomer()}`, model);
  }
  getExistingCustomerByCustomerNo(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}/${routes.getExistingByCustomerNo()}`, model);
  }
  isExist(email: string): Observable<any> {
    return this.apiService.get(`${routes.user()}/isExist/${email}`);
  }
  createShipTo(model: any): Observable<any> {
    return this.apiService.post(`${routes.userShipTo()}`, model);
  }
  createBillTo(model: any): Observable<any> {
    return this.apiService.post(`${routes.userBillTo()}`, model);
  }
  getBillTo(userCompanyId: number): Observable<any> {
    return this.apiService.get(`${routes.userBillTo()}?userCompanyId=${userCompanyId}`);
  }
  getShipTo(userId: number): Observable<any> {
    return this.apiService.get(`${routes.userShipTo()}/GetUserShipToByUserId?userId=${userId}`);
  }
  getCustomerBillTo(customerId: number): Observable<any> {
    return this.apiService.get(`${routes.userBillTo()}/GetUserCompanyBillToByCustomerId?customerId=${customerId}`);
  }
  getCustomerShipTo(customerId: number): Observable<any> {
    return this.apiService.get(`${routes.userShipTo()}/GetUserShipToByCustomerId?customerId=${customerId}`);
  }
  updateBillTo(model: any): Observable<any> {
    return this.apiService.put(`${routes.userBillTo()}`, model);
  }
  updateShipTo(model: any): Observable<any> {
    return this.apiService.put(`${routes.userShipTo()}`, model);
  }
  getUserInfo() {
    return this._adapterService.getLocalStorageValue(environment.storageKeys.userInfo);
  }
  getById(id: number = 0): Observable<any> {
    return this.apiService.get(`${routes.user()}/GetById/${id}`);
  }
  changePicture(model: any = {}): Observable<any> {
    return this.apiService.uploadFile(`Upload/UserProfilePicture`, model);
  }
  update(model: any = {}): Observable<any> {
    return this.apiService.post(`${routes.user()}/update`, model);
  }
  changeEmail(model: any = {}): Observable<any> {
    return this.apiService.post(`${routes.user()}/ChangeEmailAddress`, model);
  }
  changePassword(model: any = {}): Observable<any> {
    return this.apiService.post(`${routes.user()}/ChangePassword`, model);
  }
  getUserCompany(): Observable<any> {
    return this.apiService.get(`${routes.userCompany()}/GetUserCompanyByUserId`);
  }
  createUserFavorite(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}/CreateUserFavorite`, model);
  }
  removeUserFavorite(model: any): Observable<any> {
    return this.apiService.post(`${routes.user()}/RemoveUserFavorite`, model);
  }
  getUserBillTo(): Observable<any> {
    return this.apiService.get(`${routes.userBillTo()}/GetUserCompanyBillToByUserId`);
  }
  getUserShipTo(): Observable<any> {
    return this.apiService.get(`${routes.userShipTo()}/GetUserShipToByUserId`);
  }
}
